export default {
	"8a550bb53d155480f8155c5dc2fbf0c5": "The courses you are currently taking are not eligible for the recommended gifts",
	"cbda7bea79ea94fb9c26283a04a2a29b": "Continue to purchase"
}
